var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-goods"},[_c('navbar',{ref:"navbar",attrs:{"show-home":"","title":"信用购选品"}}),_c('div',{staticClass:"choose-goods-wrapper"},[_c('choose-goods-nav',{ref:"chooseGoods",attrs:{"nav-height":_vm.navHeight,"nav-list":_vm.navList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }